import React from 'react';
import { css } from 'twin.macro';
import { getInitials, getRandomColor } from '../../../_helpers';
function Initials({ name, id, size = '3.5rem' }) {
	return (
		<div>
			<div
				className="rounded-circle"
				css={css`
					display: flex;
					justify-content: center;
					align-items: center;
					border-radius: 50%;
					height: ${size};
					width: ${size};
				`}
				style={{ background: getRandomColor(id) }}
			>
				<span className="text-white">{getInitials(name)}</span>
			</div>
		</div>
	);
}

export default Initials;
